var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineHeightMd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 29,
    viewBox: "0 0 48 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(-9509.686 -2441.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(9509.686 2441.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(9509.686 2454.25)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 48,
    height: 3,
    rx: 1.5,
    transform: "translate(9509.686 2467.25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHeightMd);
export default __webpack_public_path__ + "static/media/line-height-md.0a97ae49d8dcd05980410cc7487c93cc.svg";
export { ForwardRef as ReactComponent };